/* eslint-disable */
import axios from "axios";
export const DASHBOARD = (state) => {
  state.isDashboard = true;
};
export const DASHBOARD_FALSE = (state) => {
  state.isDashboard = false;
};
export const TFA = (state, data) => {
  state.needsTFA = data ? true : false;
};
export const MFA_REQUIRED = (state, data) => {
  state.mfaRequired = data ? true : false;
};
export const MFA_AUTHENTICATED = (state) => {
  state.mfaRequired = false;
};
export const CHANGEOVER = (state) => {
  state.isChangeover = true;
};
export const COLLABORATE = (state) => {
  state.isCollaborate = true;
};
export const INCOMPLETE = (state) => {
  state.isIncomplete = true;
};
export const OPERATOR = (state) => {
  state.isOperator = true;
};
export const BASIC_NEEDS_SPECIALIST = (state) => {
  state.isBasicNeedsSpecialist = true;
};
export const AUTH_REQUEST = (state) => {
  state.status = "loading";
};
export const AUTH_SUCCESS = (state, data) => {
  state.status = "success";
  state.token = data.token;
  state.user = data.user;
  state.isConfirmed = data.user.confirmed;
};
export const AUTH_ERROR = (state) => {
  state.status = "error";
};
export const REQUEST_TO_VIEW = (state, target) => {
  state.requestedItem = target;
};
export const CONFIRMATION_TYPE = (state, target) => {
  state.confirmationType = target;
};
export const CONFIRMATION_TOKEN = (state, target) => {
  state.confirmationToken = target;
};

export const USER_REQUEST = (state) => {
  state.status = "requesting_user";
};
export const USER_REQUEST_SUCCESS = (state, data) => {
  state.status = "success";
  state.user = data.user;
  state.isConfirmed = data.user.confirmed;
  state.isChangeover = data.user.changeover;
};
export const USER_REQUEST_ERROR = (state) => {
  state.status = "error";
};
export const CONFIRMATION_REQUESTED = (state, data) => {
  state.isConfirmed = data.user.confirmed;
}
export const REGISTER_REQUEST = (state) => {
  state.status = "registering";
};
export const REGISTER_SUCCESS = (state, data) => {
  state.status = "success";
  state.token = data.token;
  state.user = data.user;
  state.isConfirmed = data.user.confirmed;
};
export const REGISTER_ERROR = (state) => {
  state.status = "error";
};
export const THERAPIST_RESULTS = (state, data) => {
  state.therapists = data.therapists;
};
export const PROVIDER_RESULTS = (state, data) => {
  state.providers = data.providers;
};
export const INVITATION_CODE = (state, data) => {
  state.invitation_code = data;
};
export const UPDATE_TIMEZONE = (state, data) =>{
  state.user.timezone = data;
};
export const TOGGLE_VACATION = (state) =>{
  state.user.vacation=!state.user.vacation;
};
export const LOGOUT = (state) => {
  state.status = "";
  state.token = null;
  state.user = {};
  state.therapists = null;
  state.providers = null;
  state.isCollaborate = false;
  state.isOperator = false;
  state.isBasicNeedsSpecialist = false;
  state.needsTFA = false;
  state.mfaRequired = false;
  state.isChangeover = false;
  state.isConfirmed = false;
  state.isIncomplete = false;
  state.isDashboard = false;
  state.invitation_code = null;
  localStorage.removeItem("uwillToken");
  localStorage.removeItem("uwillImpersonation");
  localStorage.removeItem("uwill_demo_authorized");
  state.communitySearchZip = null;
  delete axios.defaults.headers.common["Authorization"];
  state.providerSearchCriteria = null;
  state.providerSearchResults = null;
  state.providerSearchLoading = false;
  state.providerSearchError = null;
}
export const SET_COMMUNITY_SEARCH_ZIP = (state, zip) => {
  state.communitySearchZip = zip;
};
export const UPDATE_CALL_STATE = (state, newCallState) => {
  state.callState = newCallState;
}
export const SESSION_SETTINGS = (state, data) => {
  state.sessionSettings = data;
}
export const OPTIONAL_SETTINGS = (state, data) => {
  state.optionalSettings = data;
}
export const SET_UCOLLABORATE_VIEW_PREFERENCE = (state, preference) => {
  state.ucollaborateViewPreference = preference;
}
export const SET_UCOLLAB_REDESIGN_TOGGLE = (state, enabled) => {
  state.ucollabRedesignToggle = enabled;
}
export const PENDING_BRCS = (state, data) => {
  state.pendingBrcs = data
}
export const SET_SELECTED_PATIENT = (state, patient) => {
  state.selectedPatient = patient;
}
export const SET_SELECTED_CRISIS_CALL = (state, call) => {
  state.selectedCrisisCall = call;
}
export const INVITATION_MODAL = (state, value) => {
  state.openInvitationModal = value
}
export const PROVIDER_SEARCH_CRITERIA = (state, data) => {
  state.providerSearchCriteria = data;
};
export const PROVIDER_SEARCH_RESULTS = (state, data) => {
  state.providers = data.providers;
  state.providerSearchResults = data;
};
export const PROVIDER_SEARCH_LOADING = (state, bool) => {
  state.providerSearchLoading = bool;
};
export const PROVIDER_SEARCH_ERROR = (state, err) => {
  state.providerSearchError = err;
};
export const SET_SCREENER_ID = (state, screenerId) => {
  state.screenerId = screenerId;
};